// src/Navbar.js
import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelectedProduct } from '../contexts/SelectedProductContext';

const Navbar = () => {
  const [activeSection, setActiveSection] = useState('');
  const { selectedProduct } = useSelectedProduct();
  const navigate = useNavigate();
  const location = useLocation(); // Get current URL

  // Handle scroll and set active section
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      let scrollPos = window.scrollY + 185; // Adjust offset if necessary

      sections.forEach((section) => {
        if (section.offsetTop <= scrollPos && section.offsetTop + section.offsetHeight > scrollPos) {
          setActiveSection(section.getAttribute('id'));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Scroll to section on click
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      window.scrollTo({
        top: section.offsetTop + 716, // Adjust for fixed navbar height (70px in this case)
        behavior: 'smooth',
      });
    }
  };

  const handleNavigation = (path) => {
    setActiveSection(path);
    navigate(`/${selectedProduct}/${path}`);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top p-1 pxnav-70px">
      <div className="container-fluid px-0">
        <NavLink className="navbar-brand" to="/">
          <img src="/assets/images/logo.svg" alt="Logo" />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarText"
          aria-controls="navbarText"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarText">
          <ul className="navbar-nav ms-auto mainNav">
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
                href="#banner"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('banner');
                  // handleNavigation('home')
                }}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('about');
                }}
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'impactstories' ? 'active' : ''}`}
                href="#impactstories"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('impactstories');
                }}
              >
                Impact Stories
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${location.pathname === `/${selectedProduct}/dashboard` ? 'active' : ''}`}
                href="#dashboard"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('dashboard');
                  handleNavigation('dashboard')
                }}
              >
                Dashboard
              </a>
            </li>
          </ul>
          <span className="navbar-text">
            <a
              className={`nav-link btn btn-contact ${activeSection === 'contact' ? 'active' : ''}`}
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
              }}
            >
              Contact Us
            </a>
            {/* <Link className="btn btn-contact  me-1 mb-2" to={`${selectedProduct}/`}><img src="/assets/images/arrow_back.png" /> Back to Home</Link> */}
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
